export default __webpack_public_path__ + "locales/az/DataReassignmentDialog.json?hash=f230037092f3a6235ca62e1f0a895d81";